import { HttpInterceptorFn } from '@angular/common/http';
import { LoadingService } from '../services/loading.service';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  loadingService.isLoading.set(true);

  return next(req).pipe(
    finalize(() => {
      loadingService.isLoading.set(false);
    }),
  );
};
